export const DEFAULT_HEARTBEAT_ENDPOINT = '/gateway/api/session/heartbeat';
export const DEFAULT_IDLE_TIME: number = 60 * 1000; // 60 seconds

export const INTERVAL_TIME: number = 10 * 1000; // 10 seconds
